import { z } from "zod";

import { normalizeHistoryFields } from "../utils";
import type { UpdateTaskInput } from "./inputs";

export const TaskHistoryField = z.enum([
  "type",
  "context_stage",
  "description",
  "priority",
  "duration",
  "deadline",
  "assignee",
  "status",
  "waiting_status",
  "requested_documents",
  "dvc_search",
  "requirements_satisfied",
  "requirements_waived",
  "notes",
  "outcome",
  "decline_reason",
]);
export type TaskHistoryField = z.infer<typeof TaskHistoryField>;

type TaskHistoryFieldByKey = Record<keyof UpdateTaskInput, TaskHistoryField> &
  Record<string, TaskHistoryField | undefined>;

const TASK_HISTORY_FIELD_BY_KEY: TaskHistoryFieldByKey = {
  type: "type",
  contextStage: "context_stage",
  description: "description",
  priority: "priority",
  slaBusinessDays: "duration",
  deadlineDate: "deadline",
  assignedTo: "assignee",
  status: "status",
  waitingStatus: "waiting_status",
  requestedDocuments: "requested_documents",
  dvcSearchDetails: "dvc_search",
  satisfyRequirements: "requirements_satisfied",
  waiveRequirements: "requirements_waived",
  notes: "notes",
  solution: "outcome",
  declineReason: "decline_reason",
};

export const normalizeTaskHistoryFields = (keys: readonly string[]) =>
  normalizeHistoryFields(keys, TaskHistoryField, TASK_HISTORY_FIELD_BY_KEY);
